'use client';
import { useEffect, useState } from 'react';
import NotFoundState from '@/components/ui/NotFoundState';
import { useParams } from 'next/navigation';
import { IBusiness } from '@/modules/businesses/types';
import BackButton from '@/components/ui/BackButton';
import {
  BusinessDescription,
  BusinessDetailsInfo,
  BusinessHero,
  BusinessReviews,
} from '@/components/pages';

export default function Page() {
  const params = useParams();
  const [business, setBusiness] = useState<IBusiness | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = sessionStorage.getItem(`business-${params.id}`);
    if (stored) setBusiness(JSON.parse(stored));
    setLoading(false);
  }, [params.id]);

  if (loading) return <div>Loading...</div>;
  if (!business)
    return (
      <NotFoundState
        entity="business"
        backHref="/public/businesses"
        action={{ label: 'Browse businesses', href: '/public/businesses' }}
      />
    );

  return (
    <div className="min-h-screen">
      {/* Back Button */}
      <div className="flex items-center gap-4">
        <BackButton />
      </div>

      <div className="max-w-4xl mx-auto space-y-6">
        {/* Business Hero Section */}
        <BusinessHero
          onToolsClick={() => {}}
          isAdmin={false}
          business={business}
        />
        {/* Business Description */}
        <BusinessDescription business={business} />

        {/* Business Details Info */}
        <BusinessDetailsInfo isAdmin={false} business={business} />

        {/* Related Links (with border to fit design) */}

        {/* Business Reviews */}
        <BusinessReviews business={business} />
      </div>
    </div>
  );
}
